angular.module('jv.video.recruiter.list.controller',[])
    .controller('VideoListCtrl',['$scope', 'videoService', '$routeParams', '$rootScope', 'videoPageService',
        function($scope, videoService, $routeParams, $rootScope, videoPageService){
            $scope.isContact = videoPageService.isContact();
            var applicationEId = $scope.applicationEId = $routeParams.applicationId;
            $scope.appId = applicationEId;
            if (angular.isUndefined(applicationEId)) {
                return;
            }
            // list results
            $scope.listResult = null;

            // add a new fild "evaluationStatus" for keeping track of the state of the evaluations
            var massageResults = function(results) {
                var evalStatusHash = {};
                angular.forEach(results.evaluations, function(value) {
                    evalStatusHash[value.videoFormResponseSId] = value.status;
                });
                angular.forEach(results.resultList, function(value, index) {
                    if (angular.isDefined(evalStatusHash[value.SId])) {
                        value.evaluationStatus = evalStatusHash[value.SId];
                        results.resultList[index] = value;
                    }
                });
                return results;
            };

            //Open the question preview modal dialog.
            $scope.openQuestionPreviewModal = function(SId) {
                $rootScope.$broadcast('previewOnlyQuestionnaire', SId);
                return false;
            };

            // all results
            $scope.results = null;
            $scope.inviteReviewers = function(id) {
                $rootScope.$broadcast('SHOW_VIDEO_INVITE_MODAL', id, $scope.appId);
            };

            $scope.grantExtension = function(vfrId, deadline){
                var fullName =  $scope.appDetails.application.candidate.firstName + ' ' + $scope.appDetails.application.candidate.lastName;
                $rootScope.$broadcast('SHOW_VIDEO_INVITE_GRANT_EXTENSION_MODAL',fullName, $scope.appId, vfrId, deadline);
            };

            // Callback for the application and the contact list.
            function getVideoListCallback(result){
                result = massageResults(result);
                $scope.results = result;
                $scope.listResult = result.resultList;
                $scope.adHocVideoInterviewsEnabled = result.adHocVideoInterviewsEnabled;

                if(angular.isDefined($scope.flags)){
                    $scope.flags.loading = false;
                }
            }

            function getVideoApplicationList(){
                videoService.getApplicationList({
                    'eID': applicationEId       // this could be applicationEID or contactEID
                }, getVideoListCallback);
            }
            getVideoApplicationList();

            $rootScope.$on('LOAD_VIDEO_APPLICATIONS_LIST', function() {
                getVideoApplicationList();
            });

            //Send Reminder Modal
            $scope.sendReminder = function(id) {
                $rootScope.$broadcast('sendReminderModalClick', id);
            };
            
            $rootScope.$on('REFRESH_VIDEO_LIST', function(){
                getVideoApplicationList();
            });
        }]
    );